export module ApplicationPage {
  /**
   * HOME: Home
   */
  export const HOME = "HOME";
  /**
   * PROJECT_DETAIL: Project Detail
   */
  export const PROJECT_DETAIL = "PROJECT_DETAIL";
  /**
   * PROJECT_PLAN: Project Plan
   */
  export const PROJECT_PLAN = "PROJECT_PLAN";
  /**
   * INTERFACE_REQUIREMENT_LIST: Interface Requirement List
   */
  export const INTERFACE_REQUIREMENT_LIST = "INTERFACE_REQUIREMENT_LIST";
  /**
   * INTERFACE_LIST: Interface List
   */
  export const INTERFACE_LIST = "INTERFACE_LIST";
  /**
   * INTERFACE_DEPLOYMENT_REQUEST_LIST: Interface Deployment Request List
   */
  export const INTERFACE_DEPLOYMENT_REQUEST_LIST =
    "INTERFACE_DEPLOYMENT_REQUEST_LIST";
  /**
   * INTERFACE_DEPLOYMENT_REQUEST_DETAIL: Interface Deployment Request Detail
   */
  export const INTERFACE_DEPLOYMENT_REQUEST_DETAIL =
    "INTERFACE_DEPLOYMENT_REQUEST_DETAIL";
  /**
   * COMPONENT_PROJECT_LIST: Component Project List
   */
  export const COMPONENT_PROJECT_LIST = "COMPONENT_PROJECT_LIST";
  /**
   * COMPONENT_PROJECT_LIST_REQUEST: Component Project List Request
   */
  export const COMPONENT_PROJECT_LIST_REQUEST =
    "COMPONENT_PROJECT_LIST_REQUEST";
  /**
   * COMPONENT_PROJECT_DETAIL: Component Project Detail
   */
  export const COMPONENT_PROJECT_DETAIL = "COMPONENT_PROJECT_DETAIL";
  /**
   * COMPONENT_DEPLOYMENT_REQUEST_LIST: Component Deployment Request List
   */
  export const COMPONENT_DEPLOYMENT_REQUEST_LIST =
    "COMPONENT_DEPLOYMENT_REQUEST_LIST";
  /**
   * PROJECT_SEARCH: Project Search
   */
  export const PROJECT_SEARCH = "PROJECT_SEARCH";
  /**
   * ROOT_COMPONENT_LIST: Root Component List
   */
  export const ROOT_COMPONENT_LIST = "ROOT_COMPONENT_LIST";
  /**
   * COMPONENT_LIST: Component List
   */
  export const COMPONENT_LIST = "COMPONENT_LIST";
  /**
   * COMPONENT_DETAIL: Component Detail
   */
  export const COMPONENT_DETAIL = "COMPONENT_DETAIL";
  /**
   * COMPONENT_ADDITION: Component Addition
   */
  export const COMPONENT_ADDITION = "COMPONENT_ADDITION";
  /**
   * EDH_PROTOCOL_ATTRIBUTE: EDH Protocol Attribute
   */
  export const EDH_PROTOCOL_ATTRIBUTE = "EDH_PROTOCOL_ATTRIBUTE";
  /**
   * PARTNER_CODE_MAINTENANCE: Partner Code Maintenance
   */
  export const PARTNER_CODE_MAINTENANCE = "PARTNER_CODE_MAINTENANCE";
  /**
   * PARTNER_MAINTENANCE_DETAIL: Partner Code Maintenance Detail
   */
  export const PARTNER_CODE_MAINTENANCE_DETAIL =
    "PARTNER_CODE_MAINTENANCE_DETAIL";
  /**
   * TICKET_DETAIL: Ticket Detail
   */
  export const TICKET_DETAIL = "TICKET_DETAIL";
  /**
   * ENVIRONMENT_COPY: Environment Copy
   */
  export const ENVIRONMENT_COPY = "ENVIRONMENT_COPY";
  /**
   * DATA_KIND_MAINTENANCE: Data Kind Maintenance
   */
  export const DATA_KIND_MAINTENANCE = "DATA_KIND_MAINTENANCE";
  /**
   * FILE_LAYOUT_MAINTENANCE: File Layout Maintenance
   */
  export const FILE_LAYOUT_MAINTENANCE = "FILE_LAYOUT_MAINTENANCE";

  /**
   * USER_ROLE_MAINTENANCE: User Role Maintenance
   */
  export const USER_ROLE_MAINTENANCE = "USER_ROLE_MAINTENANCE";
  export const Pages: { [key: string]: PageConfig } = {
    /**
     * HOME: Home
     */
    HOME: {
      id: HOME,
      label: "Home",
      path: "/",
    },
    /**
     * PROJECT_DETAIL: Project Detail
     */
    PROJECT_DETAIL: {
      id: PROJECT_DETAIL,
      label: "Project Detail",
      path: "/project-detail",
    },
    /**
     * PROJECT_PLAN: Project Plan
     */
    PROJECT_PLAN: {
      id: PROJECT_PLAN,
      label: "Project Plan",
      path: "/project-plan",
    },
    /**
     * PROJECT_SEARCH: Project Search
     */
    PROJECT_SEARCH: {
      id: PROJECT_SEARCH,
      label: "Project Search",
      path: "/project-search",
    },
    /**
     * INTERFACE_REQUIREMENT_LIST: Interface Requirement List
     */
    IF_REQUIREMENT_LIST: {
      id: INTERFACE_REQUIREMENT_LIST,
      label: "Interface Requirement List",
      path: "/interface-requirement-list",
    },
    /**
     * INTERFACE_LIST: Interface List
     */
    INTERFACE_LIST: {
      id: INTERFACE_LIST,
      label: "Interface List",
      path: "/interface-list",
    },
    /**
     * INTERFACE_DEPLOYMENT_REQUEST_LIST: Interface Deployment Request List
     */
    INTERFACE_DEPLOYMENT_REQUEST_LIST: {
      id: INTERFACE_DEPLOYMENT_REQUEST_LIST,
      label: "Interface Deployment Request List",
      path: "/interface-deployment-request-list",
    },
    /**
     * INTERFACE_DEPLOYMENT_REQUEST_LIST: Interface Deployment Request List
     */
    INTERFACE_DEPLOYMENT_REQUEST_DETAIL: {
      id: INTERFACE_DEPLOYMENT_REQUEST_DETAIL,
      label: "Interface Deployment Request detail",
      path: "/deployment-request-detail",
    },
    /**
     * COMPONENT_PROJECT_LIST: Component Project List
     */
    COMPONENT_PROJECT_LIST: {
      id: COMPONENT_PROJECT_LIST,
      label: "Component Project List",
      path: "/component-project-list",
    },
    /**
     * COMPONENT_PROJECT_LIST_REQUEST: Component Project List Request
     */
    COMPONENT_PROJECT_LIST_REQUEST: {
      id: COMPONENT_PROJECT_LIST_REQUEST,
      label: "Component Project List Request",
      path: "/component-project-list-request",
    },
    /**
     * COMPONENT_PROJECT_DETAIL: Component Project Detail
     */
    COMPONENT_PROJECT_DETAIL: {
      id: COMPONENT_PROJECT_DETAIL,
      label: "Component Project Detail",
      path: "/component-project-detail",
    },
    /**
     * COMPONENT_DEPLOYMENT_REQUEST_LIST: Component Deployment Request List
     */
    COMPONENT_DEPLOYMENT_REQUEST_LIST: {
      id: COMPONENT_DEPLOYMENT_REQUEST_LIST,
      label: "Component Deployment Request List",
      path: "/component-deployment-request-list",
    },
    /**
     * ROOT_COMPONENT_LIST: Root Component List
     */
    ROOT_COMPONENT_LIST: {
      id: ROOT_COMPONENT_LIST,
      label: "Root Component List",
      path: "/root-component-list",
    },
    /**
     * COMPONENT_LIST: Component List
     */
    COMPONENT_LIST: {
      id: COMPONENT_LIST,
      label: "Component List",
      path: "/component-list",
    },
    /**
     * COMPONENT_DETAIL: Component Detail
     */
    COMPONENT_DETAIL: {
      id: COMPONENT_DETAIL,
      label: "Component Detail",
      path: "/component-detail",
    },
    /**
     * COMPONENT_ADDITION: Component Addition
     */
    COMPONENT_ADDITION: {
      id: COMPONENT_ADDITION,
      label: "Component Addition",
      path: "/component-addition",
    },

    /**
     * EDH_PROTOCOL_ATTRIBUTE: EDH Protocol Attribute
     */
    EDH_PROTOCOL_ATTRIBUTE: {
      id: EDH_PROTOCOL_ATTRIBUTE,
      label: "EDH Protocol Attribute",
      path: "/edh-protocol-attribute",
    },
    /**
     * PARTNER_CODE_MAINTENANCE: Partner Code Maintenance
     */
    PARTNER_CODE_MAINTENANCE: {
      id: PARTNER_CODE_MAINTENANCE,
      label: "Partner Code Maintenance",
      path: "/partner-list",
    },
    /**
     * PARTNER_CODE_MAINTENANCE_DETAIL: Partner Code Maintenance Detail
     */
    PARTNER_CODE_MAINTENANCE_DETAIL: {
      id: PARTNER_CODE_MAINTENANCE_DETAIL,
      label: "Partner Code Maintenance Detail",
      path: "/partner-detail",
    },
    /**
     * TICKET_DETAIL: Ticket Detail
     */
    TICKET_DETAIL: {
      id: TICKET_DETAIL,
      label: "Ticket Detail",
      path: "/ticket-detail",
    },
    /**
     * ENVIRONMENT_COPY: Environment Copy
     */
    ENVIRONMENT_COPY: {
      id: ENVIRONMENT_COPY,
      label: "Environment Copy",
      path: "/environment-copy",
    },
    /**
     * DATA_KIND_MAINTENANCE: Data Kind Maintenance
     */
    DATA_KIND_MAINTENANCE: {
      id: DATA_KIND_MAINTENANCE,
      label: "Data Kind Maintenance",
      path: "/data-kind-maintenance",
    },
    /**
     * FILE_LAYOUT_MAINTENANCE: File Layout Maintenance
     */
    FILE_LAYOUT_MAINTENANCE: {
      id: FILE_LAYOUT_MAINTENANCE,
      label: "File Layout Maintenance",
      path: "/file-layout-maintenance",
    },
    /**
     * USER_ROLE_MAINTENANCE: User Role Maintenance
     */
    USER_ROLE_MAINTENANCE: {
      id: USER_ROLE_MAINTENANCE,
      label: "User Role Maintenance",
      path: "/user-role-maintenance",
    },
  };

  export const pathById = (id: string): string => {
    return Pages[id].path;
  };

  export const pageById = (id: string): PageConfig => {
    return Pages[id];
  };

  export const pageByPath = (path: string): PageConfig | undefined =>
    Object.values(Pages).find((page) => page.path === path);

  export type PageConfig = {
    id: string;
    label: string;
    path: string;
    isModal?: boolean;
  };
}
